export enum Period {
    matutinal = 1,
    vespertine = 2,
    nocturnal = 3
}
